module.exports = __webpack_public_path__ + "img/Ticket.6366d807.svg";